export default __webpack_public_path__ + "static/media/warning.b8601420.svg";